var map = {
	"./heroes1.jpg": 4083,
	"./heroes2.jpg": 2276,
	"./heroes3.jpg": 801,
	"./heroes4.jpg": 7890,
	"./heroes5.jpg": 4239,
	"./heroes6.jpg": 2928,
	"./heroes7.jpg": 6381,
	"./heroes8.jpg": 1374,
	"./heroes9.jpg": 7835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4487;